import { useCallback } from 'react';
import { medProjectFileApi } from '@services/MedProject';
import config from '@config';
import RichEditor, { normalizeRichHtml } from '@components/common/RichEditor';

/** 医项目图文模块：medProjectFileApi 上传 */
const TinymceEditor = ({ initEditorValue: _initEditorValue, setEditorContents, editorContents, id, placeholder, form, fieldValue }) => {
    const getFileUrl = useCallback(url => {
        if (url && url.includes('https')) {
            return url;
        }
        if (url && !url.includes('https')) {
            return `${config.OSS_PREFIX}/${url}`;
        }
        return null;
    }, []);

    const imageUploadHandler = useCallback(
        async blobInfo => {
            const formData = new FormData();
            formData.append('file', blobInfo.blob());
            formData.append('type', 21);

            const res = await medProjectFileApi(formData);
            if (res && res.data) {
                return getFileUrl(res.data);
            }
        },
        [getFileUrl],
    );

    const handleChange = useCallback(
        html => {
            const normalized = normalizeRichHtml(html);
            const fieldVal = normalized === '' ? undefined : html;
            setEditorContents(fieldVal);
            if (form) {
                form.setFieldValue(fieldValue, fieldVal);
                if (fieldVal) {
                    form.setFields([{ name: fieldValue, errors: null }]);
                }
            }
        },
        [setEditorContents, form, fieldValue],
    );

    if (!id) {
        return null;
    }

    return <RichEditor id={id} mode="full" medProjectToolbar height={500} placeholder={placeholder} value={editorContents ?? ''} onChange={handleChange} imageUploadHandler={imageUploadHandler} />;
};

export default TinymceEditor;
